import React, { useState } from 'react';
import {
  Editor, Element as SlateElement, Transforms,
} from 'slate';
import { ReactEditor, useSlate } from 'slate-react';
import { KatIcon } from '@amzn/katal-react';
import { ElementTypes, LinkElement } from 'src/types/CustomSlateTypes';
import ToolbarButton from '../ToolbarButton';
import AddLinkModal, { AddLinkModalProps } from './AddLinkModal';
import hasMulipleBlocksSelected from './hasMulipleBlocksSelected';
import createUrl from './createUrl';
import isBlockActive from '../isBlockActive';

export type LinkButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const LinkButton: React.FC<LinkButtonProps> = (props) => {
  const editor = useSlate();
  const [showModal, setShowModal] = useState(false);

  let isActive = false;
  if (editor.selection && ReactEditor.hasRange(editor, editor.selection)) {
    isActive = isBlockActive(editor, ElementTypes.link);
  }

  const handleSave: AddLinkModalProps['onSave'] = (values) => {
    Transforms.unwrapNodes(editor, {
      match: (n) => !Editor.isEditor(n)
        && SlateElement.isElement(n)
        && n.type === ElementTypes.link,
    });
    if (!isActive) {
      const { text } = values;
      const url = createUrl(values.url);

      const marks = Editor.marks(editor);
      const link: LinkElement = {
        type: ElementTypes.link,
        url,
        children: [{ text: text || url, ...marks }],
      };

      if (hasMulipleBlocksSelected(editor)) {
        Transforms.wrapNodes(editor, link, { split: true });
        Transforms.collapse(editor, { edge: 'end' });
      } else {
        Transforms.insertNodes(editor, link, { select: true });
      }
    }
  };

  return (
    <>
      <ToolbarButton
        data-testid="link-button"
        isActive={isActive}
        onClick={() => {
          if (isActive) {
            Transforms.unwrapNodes(editor, {
              match: (n) => !Editor.isEditor(n)
                && SlateElement.isElement(n)
                && n.type === ElementTypes.link,
            });
          } else {
            setShowModal(true);
          }
        }}
        {...props}
      >
        <KatIcon name="link" size="small" />
      </ToolbarButton>
      {showModal && (
        <AddLinkModal
          onClose={() => { setShowModal(false); }}
          onSave={handleSave}
        />
      )}
    </>

  );
};

export default LinkButton;
